import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { Target, UserRound, Receipt, RefreshCw, Check, ArrowRight } from "lucide-react";

const iconMap = { Target, UserRound, Receipt, RefreshCw };

export default function Advisory({ onContact }) {
  const advisory = useContent().advisory;
  return (
    <section id="beratung" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-start">
        <div className="reveal lg:sticky lg:top-28">
          <div className="eyebrow mb-4">{advisory.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold leading-tight">{advisory.title}</h2>
          <p className="mt-5 text-[#5c6577] text-lg leading-relaxed">{advisory.text}</p>

          <div className="relative rounded-2xl overflow-hidden mt-8">
            <img src={advisory.image} alt="Beratung" className="w-full h-[300px] object-cover" />
          </div>

          <div className="mt-8 rounded-xl border border-[#efe9dd] bg-[#faf8f4] p-6">
            <div className="font-serif-lux text-xl text-[#16233d] mb-4">{advisory.suitableTitle}</div>
            <ul className="space-y-3">
              {advisory.suitable.map((s) => (
                <li key={s} className="flex items-start gap-2.5 text-sm text-[#3a4258]">
                  <Check size={17} className="text-[#b08d57] mt-0.5 shrink-0" /> {s}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="reveal">
          <div className="grid sm:grid-cols-2 gap-5">
            {advisory.items.map((it) => {
              const Icon = iconMap[it.icon];
              return (
                <div key={it.title} className="card-lift bg-white rounded-xl border border-[#efe9dd] p-6">
                  <div className="w-11 h-11 rounded-lg bg-[#faf3e8] flex items-center justify-center mb-4">
                    <Icon size={20} className="text-[#b08d57]" />
                  </div>
                  <h3 className="font-serif-lux text-xl text-[#16233d] mb-2">{it.title}</h3>
                  <p className="text-[#5c6577] text-sm leading-relaxed">{it.text}</p>
                </div>
              );
            })}
          </div>
          <button onClick={onContact} className="btn-gold rounded-md px-6 py-3.5 font-medium mt-8 inline-flex items-center gap-2">
            {advisory.cta} <ArrowRight size={17} />
          </button>
        </div>
      </div>
    </section>
  );
}
